/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createGirConfiguration } from '../fn/gir/create-gir-configuration';
import { CreateGirConfiguration$Params } from '../fn/gir/create-gir-configuration';
import { exportConnectionTagsGirApiDefinition } from '../fn/gir/export-connection-tags-gir-api-definition';
import { ExportConnectionTagsGirApiDefinition$Params } from '../fn/gir/export-connection-tags-gir-api-definition';
import { getGirConfiguration } from '../fn/gir/get-gir-configuration';
import { GetGirConfiguration$Params } from '../fn/gir/get-gir-configuration';
import { GirConfig } from '../models/gir-config';
import { importConnectionTagsGirApiDefinition } from '../fn/gir/import-connection-tags-gir-api-definition';
import { ImportConnectionTagsGirApiDefinition$Params } from '../fn/gir/import-connection-tags-gir-api-definition';
import { listGirConfigurations } from '../fn/gir/list-gir-configurations';
import { ListGirConfigurations$Params } from '../fn/gir/list-gir-configurations';
import { removeGirConfiguration } from '../fn/gir/remove-gir-configuration';
import { RemoveGirConfiguration$Params } from '../fn/gir/remove-gir-configuration';
import { setGirConfiguration } from '../fn/gir/set-gir-configuration';
import { SetGirConfiguration$Params } from '../fn/gir/set-gir-configuration';


/**
 * All about the GIR connections
 */
@Injectable({ providedIn: 'root' })
export class GirService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listGirConfigurations()` */
  static readonly ListGirConfigurationsPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/gir';

  /**
   * List the station GIR configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGirConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGirConfigurations$Response(params: ListGirConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GirConfig>>> {
    return listGirConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List the station GIR configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGirConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGirConfigurations(params: ListGirConfigurations$Params, context?: HttpContext): Observable<Array<GirConfig>> {
    return this.listGirConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GirConfig>>): Array<GirConfig> => r.body)
    );
  }

  /** Path part for operation `createGirConfiguration()` */
  static readonly CreateGirConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/gir';

  /**
   * Create a station GIR configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createGirConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGirConfiguration$Response(params: CreateGirConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createGirConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station GIR configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createGirConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGirConfiguration(params: CreateGirConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createGirConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getGirConfiguration()` */
  static readonly GetGirConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/gir/{girUid}';

  /**
   * Get a station gir configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGirConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGirConfiguration$Response(params: GetGirConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<GirConfig>> {
    return getGirConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station gir configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGirConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGirConfiguration(params: GetGirConfiguration$Params, context?: HttpContext): Observable<GirConfig> {
    return this.getGirConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<GirConfig>): GirConfig => r.body)
    );
  }

  /** Path part for operation `setGirConfiguration()` */
  static readonly SetGirConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/gir/{girUid}';

  /**
   * update a station gir configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setGirConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setGirConfiguration$Response(params: SetGirConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setGirConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * update a station gir configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setGirConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setGirConfiguration(params: SetGirConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.setGirConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeGirConfiguration()` */
  static readonly RemoveGirConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/gir/{girUid}';

  /**
   * Remove the station gir configuration.
   *
   * Remove Gir configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeGirConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeGirConfiguration$Response(params: RemoveGirConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeGirConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station gir configuration.
   *
   * Remove Gir configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeGirConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeGirConfiguration(params: RemoveGirConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeGirConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportConnectionTagsGirApiDefinition()` */
  static readonly ExportConnectionTagsGirApiDefinitionPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/gir/configuration/{girUid}/export';

  /**
   * Export the GIR API tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid girUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportConnectionTagsGirApiDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsGirApiDefinition$Response(params: ExportConnectionTagsGirApiDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportConnectionTagsGirApiDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the GIR API tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid girUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportConnectionTagsGirApiDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsGirApiDefinition(params: ExportConnectionTagsGirApiDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportConnectionTagsGirApiDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importConnectionTagsGirApiDefinition()` */
  static readonly ImportConnectionTagsGirApiDefinitionPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/gir/configuration/{girUid}/import';

  /**
   * Import the GIR API tags definitions for a connection.
   *
   * Allows to import the GIR API tags definitions, via a XLS File.
   * The connectionUid must be a valid girUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importConnectionTagsGirApiDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsGirApiDefinition$Response(params: ImportConnectionTagsGirApiDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importConnectionTagsGirApiDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the GIR API tags definitions for a connection.
   *
   * Allows to import the GIR API tags definitions, via a XLS File.
   * The connectionUid must be a valid girUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importConnectionTagsGirApiDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsGirApiDefinition(params: ImportConnectionTagsGirApiDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importConnectionTagsGirApiDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
